import { render, staticRenderFns } from "./FlyerBlock.vue?vue&type=template&id=3df9b099&scoped=true&"
import script from "./FlyerBlock.vue?vue&type=script&lang=js&"
export * from "./FlyerBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df9b099",
  null
  
)

export default component.exports